import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ToTop extends React.PureComponent {
    static propTypes = {
        base62Id: PropTypes.string,
    };

    state = {
        toTopIsShow: false,
    };

    handleToTop = () => {
        window.scroll(0, 0);
    };

    componentDidMount() {
        window.onscroll = () => {
            const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

            const winHeight = document.body.clientHeight;

            // console.log(winHeight);

            if (scrollTop > 400 && scrollTop <= winHeight - 0) {
                this.setState({
                    toTopIsShow: true,
                });
            } else {
                this.setState({
                    toTopIsShow: false,
                });
            }
        };
    }

    render() {
        const { toTopIsShow } = this.state;
        const { base62Id } = this.props;

        return (
            <div className={styles.toTop}>
                <div className={styles.qrCodeBox} id="">
                    <div className={styles.qrCode}>
                        <a
                            href="https://a.ifeng.com/?from=pcVideo"
                            target="_blank"
                            sign-trs-href="https://a.ifeng.com/?from=pcVideo">
                            <img
                                src="//x0.ifengimg.com/ucms/qr/2021_09/870CE559BCBD54DB36A25BFBFF6A8155BD3FAD3D_size1_w260_h260.png"
                                alt=""
                                title=""
                            />
                        </a>
                    </div>
                    <p className={styles.codeBlack}>电视不播的</p>
                    <p className={styles.codeGray}>真相在这找</p>
                </div>
                <div className={styles.vPanelFeed} id="js_vfeed">
                    <div className={styles.vPanelFeedSimple}>
                        <a
                            className={styles.vPanelFeedView}
                            href={`https://client.ifeng.com/report/artical?docid=${base62Id}`}
                            title=""
                            target="_blank"
                            sign-trs-href={`https://client.ifeng.com/report/artical?docid=${base62Id}`}>
                            <em>算法反馈</em>
                        </a>
                    </div>
                </div>
                {/* {toTopIsShow ? ( */}
                <div
                    className={styles.vPanelTop}
                    style={{ display: toTopIsShow ? 'block' : 'none' }}
                    onClick={this.handleToTop}>
                    <div className={styles.vPanelTopSimple}>
                        <span className={styles.vPanelTopView} title="返回顶部">
                            <em>返 回</em>
                        </span>
                    </div>
                </div>
                {/* ) : null} */}
            </div>
        );
    }
}

export default errorBoundary(ToTop);
